export default __webpack_public_path__ + "static/media/Think5WhysCertTemplateDec24.2418eee8cdbe9fa88048a1a3904a1aac.png";